import React from 'react'

const PlayerMain = (props) => {

  const {
    openClasses,
    startLibrary,
    mode
  } = props
  return (
    <div className="main-selection">
      <div className={`classes ${mode === 'class' ? 'active' : ''}`} onClick={() => openClasses()}>
        <img src="img/play-button.svg"/>
        <span>Start<br/>class</span>
      </div>
      <div className={`library ${mode === 'library' ? 'active' : ''}`} onClick={() => startLibrary()}>
        <img src="img/library-button.svg"/>
        <span>Pre/Post<br/>class</span>
      </div>
    </div>
  )
}

export default PlayerMain


// WEBPACK FOOTER //
// ./src/modules/player/PlayerMain.js